import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { callEditorApi } from 'owa-editor/lib/utils/callEditorApi';
import getSelectedImage from 'owa-editor/lib/utils/getSelectedImage';
import { createRange } from 'roosterjs-editor-dom';

//Check if the selection is an image and if it is a image, select with the editor.
export const checkAndSelectImage = (editorViewState: EditorViewState) => {
    const range = callEditorApi(editorViewState, 'getSelectionRange');
    if (range?.collapsed) {
        const image = getSelectedImage(editorViewState, true);
        if (!image) {
            return;
        }
        const imageRange = createRange(image);
        // Using "any" type and undefined parameter to workaround a limitation that the compiler didn't correctly read function override
        callEditorApi(editorViewState, 'select', imageRange as any, undefined as any);
    }
};
